import { ChangeEvent, useMemo, useState, useCallback } from 'react';

import _ from 'lodash';

export const useSearchField = <T>(
  searchList: T[],
  searchField: string | string[],
) => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedInputValue, setDebouncedInputValue] = useState('');

  const filteredParticipants = useMemo(() => {
    if (!debouncedInputValue) {
      return searchList;
    }

    return searchList.filter((searchItem) => {
      let searchValue;

      if (Array.isArray(searchField)) {
        const field = searchField.find((field) => _.get(searchItem, field));
        if (field) {
          searchValue = _.get(searchItem, field);
        }
      } else {
        searchValue = _.get(searchItem, searchField);
      }

      searchValue = searchValue || _.get(searchItem, 'participant.email');

      return searchValue
        ?.toLowerCase()
        .includes(debouncedInputValue.toLowerCase());
    });
  }, [debouncedInputValue, searchField, searchList]);

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
      handleDebounceInputChange(event);
    },
    [],
  );

  const handleDebounceInputChange = useCallback(
    _.debounce((event: ChangeEvent<HTMLInputElement>) => {
      setDebouncedInputValue(event.target.value);
    }, 300),
    [],
  );

  const handleInputClear = useCallback(() => {
    setInputValue('');
    setDebouncedInputValue('');
  }, []);

  return {
    inputValue,
    filteredData: filteredParticipants,
    handleInputChange,
    handleInputClear,
  };
};
